import { callApi } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import {
  IFormData,
  IFormResponse,
  IFormReviewAndRatingResponse,
  IFormSubmissionPayload,
  IFormViewResponse,
} from '@/interfaces/form.model';
import { IFilter } from '@/interfaces/common.model';
import { getFilterUrl } from '@/utility/helper';
import { IDesignationResponse } from '@/pages/HRM/HrmSettings/Designation/Designation';
import { IUser } from '@/interfaces/user.model';

interface IEmployeeResponse {
  status: boolean;
  message: string;
  data: {
    user: IUser[];
  };
}

export const FormService = {
  getForms: async (filter?: IFilter): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getForms}?${getFilterUrl(filter || {})}`;
    return callApi<IFormResponse>(API, { method: 'GET' });
  },

  getFormById: async (
    id: string,
    userId?: string,
  ): Promise<IFormViewResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getFormById}/${id}?userId=${userId}`;
    return callApi<IFormViewResponse>(API, { method: 'GET' });
  },

  createForm: async (formData: Partial<IFormData>): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.createForm}`;
    return callApi<IFormResponse>(API, {
      method: 'POST',
      data: formData,
    });
  },

  formSubmission: async (
    formData: IFormSubmissionPayload,
  ): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.formSubmission}`;
    return callApi<IFormResponse>(API, {
      method: 'POST',
      data: formData,
    });
  },

  updateForm: async (
    id: string,
    data: Partial<IFormData>,
  ): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.updateForm}/${id}`;
    return callApi<IFormResponse>(API, {
      method: 'PUT',
      data,
    });
  },

  deleteForm: async (id: string): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.deleteForm}/${id}`;
    return callApi<IFormResponse>(API, {
      method: 'GET',
    });
  },

  getSubmissionForms: async (
    id?: string | undefined,
    filter?: IFilter,
  ): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getSubmissionForms}${id ? `/${id}` : ''}?${getFilterUrl(filter || {})}`;
    return callApi<IFormResponse>(API, { method: 'GET' });
  },

  getTeamsFormSubmission: async (
    id?: string | undefined,
    filter?: IFilter,
  ): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getTeamsFormSubmission}${id ? `/${id}` : ''}?${getFilterUrl(filter || {})}`;
    return callApi<IFormResponse>(API, { method: 'GET' });
  },

  getDesignation: async (): Promise<IDesignationResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getDesigantion}`;
    return callApi<IDesignationResponse>(API, { method: 'GET' });
  },

  getEmployee: async (): Promise<IEmployeeResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getEmployee}`;
    return callApi<IEmployeeResponse>(API, { method: 'GET' });
  },

  submitManagerReview: async (
    id: string,
    payload: {
      managerRating: number;
      managerRemark: string;
    },
  ): Promise<IFormReviewAndRatingResponse> => {
    const API = `${API_URL}${API_ENDPOINT.submitManagerReview}/${id}`;
    return callApi<IFormReviewAndRatingResponse>(API, {
      method: 'POST',
      data: payload,
    });
  },
};
